export const BusinessUnit = {
  CREDITAS_PARTNERSHIP_AUTO_REFI: 'PAE',
}
